// extracted by mini-css-extract-plugin
export default {"input":"Input_input__JygE4","inputDisabled":"Input_inputDisabled__FKDNu"};